<template>
  <div id="containerHomeNeedsPage">
    <div id="containerHomeNeedsChips">
      <label class="area-label text-xs-left">Select From Standard Needs:</label>
      <div class="chips">
        <v-chip
          v-for="(need, index) in allNeeds"
          :key="index"
          class="my-chip"
          :class="{
            'chip-selected':
              selectedHomeNeeds.findIndex(elem => elem.text === need.text) !==
              -1
          }"
          text-color="white"
          color="#bbb"
          disabled
          @click="chipClicked(need)"
        >
          {{ need.text }}
        </v-chip>
      </div>
    </div>
    <div class="container-input text-xs-center">
      <label class="area-label">Enter Your Own Needs:</label>
      <input v-model="newNeed" type="text" @keydown.enter="addNewNeeds">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    suggestions: {
      type: Array,
      required: true
    },
    chosen: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      newNeed: '',
      selectedHomeNeeds: [],
      customItems: []
    }
  },
  computed: {
    allNeeds() {
      return [...this.suggestions, ...this.customItems]
    }
  },
  mounted() {
    this.selectedHomeNeeds = [...this.chosen]
  },
  methods: {
    addNewNeeds() {
      if (this.newNeed) {
        const need = { text: this.newNeed, wantNeed: 'Need' }
        this.customItems.push(need)
        this.selectedHomeNeeds.push(need)
        this.newNeed = ''
        this.$emit('changed')
      }
    },
    chipClicked(val) {
      const index = this.selectedHomeNeeds.findIndex(
        need => need.text === val.text
      )
      if (index >= 0) {
        this.selectedHomeNeeds.splice(index, 1)
      } else {
        this.selectedHomeNeeds.push(val)
      }
      this.$emit('changed')
    },
    submit() {
      return this.$emit('submit', this.selectedHomeNeeds)
    }
  }
}
</script>

<style scoped lang="sass">

#containerHomeNeedsPage
  height: 100%
  width: 100%
  margin: 0 auto

.my-chip
  height: 20px
  font-size: $hwayzFont1rem
  margin: 3px

.my-chip >>> .v-chip__content
  padding-left: 10px !important

.chip-selected
  background-color: $hwayzTapestry !important

#containerHomeNeedsChips
  text-align: left
  flex: 0 0 100%
  margin: 0% 14%
  font-size: 12px

.chips
  height: 287px
  overflow-y: scroll

    /* Scrollbar style */
.chips::-webkit-scrollbar-track
  background-color: $hwayzce
  border: solid 1px white // make the track seem narrower than the thumb

.chips::-webkit-scrollbar
  width: 4px
  background-color: $hwayzce

.chips::-webkit-scrollbar-thumb
  background-color: $hwayzBlack

.container-input
  width: fit-content
  margin: 10px auto 0

input[type="text"]
  display: block
  text-align: center
  font-size: $hwayzFont1rem4
  border-bottom: 1px black solid

.area-label
  display: block
  text-transform: capitalize
  font-size: $hwayzFont1rem4
  margin-bottom: 10px !important

*:focus
  outline: none
</style>
